// removed by extract-text-webpack-plugin
module.exports = {"buttonEdit":"_1J3rPevscOgu6D0AlazuKn","actions":"iZg1FtDDR5yrz4gWj37cR","green":"_3-kt5DebJCNhFhrE3WbiQ8","yellow":"_1e3-WROX-IewFZhSS2fNFb","red":"_18N9gW-xWLg4SGtlmgoQHy","removed":"_24KU-n5wnSlRJby-psqePa"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Work/style.scss
// module id = 1061
// module chunks = 0